/**
 * Role Key Constants
 * 
 * These constants reference the role keys defined in the backend database.
 * They provide type safety and prevent typos when checking user roles.
 * 
 * IMPORTANT: These must match the 'key' field of roles in the backend database.
 * If roles are added/modified in the database, update these constants accordingly.
 */

export const ROLE_KEYS = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    STUDENT: 'STUDENT',
    FINANCE_STAFF: 'FINANCE_STAFF',
    STAFF: 'STAFF',
} as const;


